import { render, staticRenderFns } from "./OrderSelector.vue?vue&type=template&id=d11bafd8&"
import script from "./OrderSelector.vue?vue&type=script&lang=ts&"
export * from "./OrderSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports